export const AI_ASSISTANT_SEND_EXAMPLE_MESSAGE_EVENT =
  'ai-assistant-send-example-message';
export const MARK_START_HINTS_EVENT = 'ai-assistant-start-hints';

export interface AiAssistantExampleMessageDetail {
  message: string;
}

// Bridges UI mounted outside the chat render tree (e.g. the walkthrough modal,
// rendered at the app root) to the chat, which owns the send-message flow.
export const dispatchAiAssistantExampleMessage = (message: string): void => {
  window.dispatchEvent(
    new CustomEvent<AiAssistantExampleMessageDetail>(
      AI_ASSISTANT_SEND_EXAMPLE_MESSAGE_EVENT,
      { detail: { message } }
    )
  );
};

// Bridges the root-mounted walkthrough modal to the page-mounted feature hints
// provider, which owns hint tour state and rendering.
export const dispatchMarkStartHints = (): void => {
  window.dispatchEvent(new CustomEvent(MARK_START_HINTS_EVENT));
};
